<template>
  <BaseLayout @click-back="back" isFunction="true" hasBottomButton="true" hasHeaderBar="true">
    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.customerAbbreviationStart" />

      <div class="input-group-prepend">
        <div class="input-group-text" style="width:2rem">~</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.customerAbbreviationEnd" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">業務員</div>
      </div>
      <input v-model="searchData.staffId" type="text" class="form-control" />

      <div class="input-group-prepend">
        <div class="input-group-text">客服</div>
      </div>
      <input type="text" class="form-control" v-model="searchData.assistantId" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">客戶名稱</div>
      </div>
      <input v-model="searchData.customerName" type="text" class="form-control" />
    </div>

    <!-- <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">電話號碼</div>
      </div>
      <input v-model="searchData.telephoneNo1" type="text" class="form-control" />
    </div>

    <div class="input-group">
      <div class="input-group-prepend">
        <div class="input-group-text">國別</div>
      </div>
      <input v-model="searchData.countryCode" type="text" class="form-control" />
    </div>-->

    <div class="list-group" style="text-align: left;">
      <template v-for="(form,index) in gridData">
        <div :key="form.CustomerId" class="list-group-item list-group-item-action">
          <div
            class="d-flex w-100 justify-content-between"
            style=" background:#EEE; padding: 5px 5px 0px 5px"
          >
            <b class="mb-1">
              <!-- <i class="fas fa-building"></i> -->
              {{form.CustomerId}} {{form.CustomerName}}
            </b>
            <!-- <h5
              class="badge badge-success"
              style="width:50%; 
              overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
     word-break: break-all;"
            >
              <span style="font-size:1rem;font-weight: 400;">{{form.Department}}</span>
            </h5>-->
          </div>
          <div class="d-flex flex-row">
            <p class="mb-1 w-100" style="backgroun-color:#EEE;  word-break: break-all;">
              <span class="badge badge-light">業務員:{{form.StaffId}}{{form.StaffName}}</span>
              <span class="badge badge-light">客服:{{form.AssistantId}}{{form.AssistantName}}</span>
            </p>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">行業別:{{form.BusinessCode}}</span>
            <span class="badge badge-light">地區別:{{form.AreaCode}}</span>
            <span class="badge badge-light">交易幣別:{{form.TradeCurrency}}</span>
          </div>
          <div class="d-flex flex-row">
            <span class="badge badge-light">計稅方式:{{form.TaxCode}}</span>
            <span class="badge badge-light">營業稅率:{{form.TaxRate}}</span>
          </div>
          <!-- <small v-if="form.Supplier" style="color:#888;float:right;">供應商: {{form.Supplier}}</small> -->
          <!-- <small style="float:right; color:#888;">
            <i class="fas fa-user"></i>
            {{form.EmployeeName}}
          </small>-->
        </div>
      </template>
    </div>

    <button @click="getData" type="button" class="btn-xl btn btn-primary btn-circle">
      <i class="fas fa-search"></i>
    </button>
  </BaseLayout>
</template>
<script>
export default {
  name: "CustomerInquiry",
  data: function() {
    return {
      searchData: {
        companyId: this.$store.state.companyId,
        customerAbbreviationStart: "",
        customerAbbreviationEnd: "",
        countryCode: "",
        staffId: "",
        assistantId: "",
        customerName: "",
        telephoneNo1: ""
      },
      gridData: []
    };
  },
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    getData: function() {
      var _this = this;
      this.startLoad();
      _this.$http
        .post("/WebApp/CustomerInquiry/Query", {
          ...this.searchData
        })
        .then(res => {
          _this.gridData = res.data;
          _this.endLoad();
        })
        .catch(err => {
          _this.endLoad();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-circle.btn-xl {
  position: fixed;
  bottom: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}
input[type="date"] {
  padding: 0;
}
.input-group-text {
  width: 6rem;
}
</style>